// assets/product-list.js
(function(){
  // DOM ready helper
  function onReady(fn){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // Simple tabs: click button → activate matching panel
  function initTabs() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.js-tab-button'));
    var panels  = Array.prototype.slice.call(document.querySelectorAll('.js-tab-content'));

    if (buttons.length !== panels.length) {
      console.warn('Tabs: mismatch btns vs panels');
    }

    buttons.forEach(function(btn, i){
      btn.addEventListener('click', function(){
        // reset all
        buttons.forEach(function(b){ b.classList.remove('is-active'); b.disabled = false; });
        panels .forEach(function(p){ p.classList.remove('is-open'); });

        // activate clicked
        btn.classList.add('is-active');
        btn.disabled = true;
        panels[i].classList.add('is-open');

        // after a new tab opens, ensure slider resizes
        var slider = panels[i].querySelector('.js-product-slider');
        if (slider && slider._flickity) {
          slider._flickity.resize();
        }
      });
    });
  }

  // Only use Flickity when viewport ≤ 1024px
  function shouldUseSlider() {
    return window.matchMedia('(max-width: 1024px)').matches;
  }

  // Initialize Flickity on each visible slider
  function initSliders() {
    if (!shouldUseSlider()) return;

    var sliders = document.querySelectorAll('.js-product-slider');
    sliders.forEach(function(slider){
      // destroy existing instance if re‑init
      if (slider._flickity) {
        slider._flickity.destroy();
      }
      slider._flickity = new Flickity(slider, {
        cellSelector:      '.js-product-item',
        contain:           true,
        cellAlign: 'center',
        wrapAround:        true,
        pageDots:          false,
        prevNextButtons:   false,
        imagesLoaded:      true,
      });
    });
  }

  // Destroy all Flickity instances (when switching back to grid)
  function destroySliders() {
    var sliders = document.querySelectorAll('.js-product-slider');
    sliders.forEach(function(slider){
      if (slider._flickity) {
        slider._flickity.destroy();
        delete slider._flickity;
      }
    });
  }

  // Re‑init or destroy sliders on resize
  function onResize() {
    if (!shouldUseSlider()) {
      destroySliders();
    }
    initSliders();
  }

  // When a tab opens via MutationObserver, re‑layout that Flickity instance
  function watchTabChanges() {
    var panels = document.querySelectorAll('.js-tab-content');
    panels.forEach(function(panel){
      var observer = new MutationObserver(function(mutations){
        mutations.forEach(function(m){
          if (m.attributeName === 'class' && panel.classList.contains('is-open')) {
            var slider = panel.querySelector('.js-product-slider');
            if (slider && slider._flickity) {
              slider._flickity.resize();
            }
          }
        });
      });
      observer.observe(panel, { attributes: true });
    });
  }

  onReady(function(){
    initTabs();
    initSliders();
    watchTabChanges();
    window.addEventListener('resize', onResize);
  });
})();
